import authSelector from 'modules/Auth/selectors'
import SuccessMessage from 'utils/SuccessMessage'
import request from 'utils/request'
import ErrorMessage from 'utils/ErrorMessage'

export const updateUserData = payload => async (dispatch, getState) => {
  const state = getState()
  const userId = authSelector.getUserId(state)
  try {
    let data = await request.put(`/user/${userId}`, payload)
    return data
  } catch (error) {
    return error
  }
}

export const changePassword = payload => async (dispatch, getState) => {
  const state = getState()
  const userId = authSelector.getUserId(state)
  try {
    let data = await request.patch(`/user/${userId}/password`, payload)
    return data
  } catch (error) {
    return error
  }
}

export const updateNotification = payload => async (dispatch, getState) => {
  const state = getState()
  const userId = authSelector.getUserId(state)
  try {
    await request.put(`/user/${userId}/notification-preference`, payload)
    return true
  } catch (error) {
    return error
  }
}

export const SendOtp = payLoad => async (dispatch, getState) => {
  const state = getState()
  const userId = authSelector.getUserId(state)
  try {
    let response = await request.post(`/users/${userId}/sendotp`, payLoad)
    if(response?.status === 201 && response.status != undefined){
      response?.data?.message === 'Success' &&
      SuccessMessage('OTP Sent Successfully')
      return response?.data?.message === 'Success'
    }
 
   if(response?.response?.status === 400){
    ErrorMessage('Please request to send otp after One minute');
    return response?.response?.data?.message
   }
    
  } catch (error) {
    return error
  }
}

export const checkOtp = payLoad => async (dispatch, getState) => {
  const state = getState()
  const userId = authSelector.getUserId(state)

  try {
    const data = await request.patch(`/users/${userId}/phone`, payLoad)

    SuccessMessage('OTP Verified Successfully')
    return data
  } catch (error) {
    return error
  }
}

export const deleteFile = fileUrl => async () => {
  try {
    if (fileUrl) {
      const data = await request.delete(`/deleteFile`, {
        data: { fileUrl: fileUrl },
      })

      if (data.status >= 200 && data.status < 300) {
        return true
      }
    } else {
      return false
    }
  } catch (error) {
    return false
  }
}
